<!--  -->
<template>
  <div class="content">
    <div class="ban">
      <img src="../../assets/img/anli/ban2.png" @click="jump" alt="" />
    </div>
    <!-- 平台介绍 -->
    <div class="Platform_introduction">
      <div class="card">
        <div class="left">
          <div class="all_text">
            <img src="../../assets/img/index/ico.png" alt="" />
            <div class="text">
              货运管理<br />
             系统简介
            </div>
            <div class="row"></div>
          </div>
          <div class="info">
            <div>
              系统实现了货物由“发货客户工厂装货”到“送货完成”的全过程模拟操作和控制。
            </div>
            <div>
              支持多分支机构联运操作的业务模式，采用流水线式操作流程。实时监控货物运输流程及状态，并按权级管理财务数据，合理优化装载效率和运输模式，降低物流成本，实现货物流、资金流、信息流的同步。
            </div>
           
          </div>
        </div>
      </div>
      <div class="left_img">
        <img class="img" src="../../assets/servie/img.png" alt="" />
      </div>
    </div>

    <!-- 平台模板 -->
    <div class="Platform_template">
      <div class="img_ab">
        <img src="../../assets/img/anli/bg.png" alt="" />
      </div>
      <div class="info card">
        <Link text="系统主要功能模块" />

        <div class="">
          <div class="list card">
            <div
              class="li"
              v-for="(item, index) in card_list"
              :key="index"
              v-show="index < 6"
            >
              <img :src="item.img" alt="" />
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
          <div class="list card">
            <div
              class="li"
              v-for="(item, index) in card_list"
              :key="index"
              v-show="index > 5"
            >
              <img :src="item.img" alt="" />
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 系统主要五个模块 -->
    <div class="sys card">
      <Link text="系统主要五个模块" />
      <div class="sys_list">
        <div class="li" v-for="(item, index) in sys_list" :key="index">
          <div class="title">
            {{ item.title }}
          </div>
          <img :src="item.img" alt="" />
          <div class="text">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";
import Footer from "../../components/footer";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
    Footer,
  },
  data() {
    //这里存放数据
    return {
      sys_list: [
        {
          title: "01",
          text: "具备可记录、可追溯、可查询、可分析、可预警等功能。",
          img: require("../../assets/img/shop/ico1.png"),
        },
        {
          title: "02",
          text: "支持一单业务多部门联合运输操作，实现流程化管控。",
          img: require("../../assets/img/shop/ico2.png"),
        },
        {
          title: "03",
          text: "单证和运输操作数据共享，财务数据按权限分级管理。",
          img: require("../../assets/img/shop/ico3.png"),
        },
        {
          title: "04",
          text: "促进货物流、资金流、信息流的无缝衔接，实现三流合一。",
          img: require("../../assets/img/shop/ico4.png"),
        },
        {
          title: "05",
          text: "实现了客户询价到委托运输、财务结算的全流程操作管控。",
          img: require("../../assets/img/shop/ico5.png"),
        },
      ],
     
      card_list: [
        {
          img: require("../../assets/servie/f1.png"),
          text: "货运首页",
        },
        {
          img: require("../../assets/servie/ioc1.png"),
          text: "现场管理",
        },
        {
          img: require("../../assets/servie/ioc3.png"),
          text: "合同管理",
        },
        
        {
          img: require("../../assets/servie/ioc4.png"),
          text: "单证管理",
        },
        
        {
          img: require("../../assets/servie/ioc5.png"),
          text: "操作管理",
        },
        {
          img: require("../../assets/servie/16.png"),
          text: "统计查询",
        },
        {
          img: require("../../assets/servie/ioc12.png"),
          text: "档案管理",
        },
        {
          img: require("../../assets/servie/14.png"),
          text: "贸易管理",
        },
     
        {
          img: require("../../assets/servie/13.png"),
          text: "报表管理",
        },
        {
          img: require("../../assets/servie/f2.png"),
          text: "系统管理",
        },
        {
          img: require("../../assets/servie/f4.png"),
          text: "报价管理",
        },
        {
          img: require("../../assets/servie/f3.png"),
          text: "财务管理",
        },
      ],
     
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //跳转
    topUrl(index, url) {
      this.$router.push(url);
      this.$store.state.current = index;
      this.drawer = false;
      this.current = index;
      localStorage.setItem("current", this.current);
    },
    // 底部
    jump(index) {
      let jump = document.getElementById("d_jump");
      // 获取需要滚动的距离
      let total = jump.offsetTop;
      console.log(jump.offsetTop);

      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
@import url(../service_education/pc);
@import url(../service_education/mod);
  //系统主要五个模块
  .sys {
    .sys_list {
        display: flex;
        justify-content: space-between;
        padding: 58px 0 150px 0;

        .li {
            width: 225px;
            height: 300px;
            background: #FFFFFF;
            box-shadow: 0px 8px 48px 0px #EFF5FE;

            .title {
                background: #EFF5FE;
                font-size: 30px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #006EFF;
                text-align: center;
                margin: 20px;
            }

            img {
                margin-left: 50%;
                transform: translateX(-50%);
                padding: 20px 0;
            }

            .text {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                line-height: 24px;
                text-align: center;
                padding: 0 10px;
            }
        }
    }
}
// 小屏幕
@media (max-width: 1279px) {
  .sys{
      .sys_list{
          .li{
              width: 170px !important;
              height: 300px !important;
          }
      }
  }

}
// 中屏幕
@media screen and (max-width: 1600px) and (min-width:1280px) {
  .sys{
      .sys_list{
          .li{
              width: 200px !important;
              height: 300px !important;
          }
      }
  }

}

</style>